/* eslint-disable react/jsx-no-target-blank */
import AsideMenuData from 'src/app/components/AsideMenuData'

export const AsideMenuMain = AsideMenuData
